/* ======================================================
SHOPIFY ROUTINE QUIZ ENGINE
====================================================== */
/* ------------------------------------------------------
1. Routine Mapping
------------------------------------------------------ */
let isRenderingStrip = false;

let routine = null;
let quizStep = 0;
let routineStep = 0;
let selectedProducts = [];
let selectedproductsHandle = [];

let selectedAge = null;
let selectedSkinType = null;
let selectedSkinConcern = null;
let selectedSecondaryConcern = null;

const ROUTINE_SESSION_KEY = "routine_builder_state";

/* ======================================================
QUIZ CONFIG
====================================================== */
const stepLabels = {
  details: "Basic Info",
  lifestyle: "Lifestyle",
  foodHabit: "Eating Habits",
  skinConcern: "Skin Concern",
  secondaryConcern: "Skin Concern"
};

const quizConfig = [

  { step: "details", title: "Some details" },

  {
    step: "lifestyle", title: "Tell us about your Lifestyle", mapping: false, options: [
      "Don’t Get Enough Sleep",
      "Often Feel Stressed",
      "Mostly Balanced Routine",
      "Mostly Indoors During the Day",
      "Outdoors a Lot",
      "Poor Sleep & High Stress",
      "Mostly in AC / Indoor Spaces"
    ]
  },

  {
    step: "foodHabit", title: "What are your usual eating habits like?", mapping: false, options: [
      "Enjoy Junk Food Occasionally",
      "Eat a Fairly Balanced Diet",
      "Mostly Eat Home-Cooked Food",
      "Try to Eat Clean Most Days",
      "Have Dairy Quite Often",
      "Don’t Drink Enough Water"
    ]
  },

  {
    step: "skinConcern", title: "What is your main skin concern right now?", mapping: true,
    options: ["acne", "pigmentation", "glow", "ageing", "dryness"]
  },

  {
    step: "secondaryConcern", title: "Pick a concern related to your main skin issue",
    mapping: true, dynamic: true
  }

];


/* ======================================================
STATE
====================================================== */

const quizState = {};
// let currentStep = 0;
let routineData = null;
const productCache = {};


/* ======================================================
INIT
====================================================== */

document.addEventListener("DOMContentLoaded", () => {

  restoreState();

  //  Fix invalid step after restore
  if (!quizConfig[quizStep]) {
    quizStep = 0;
  }

 renderStep();
updateNextButtonState();

  const nextBtn = document.getElementById("nextBtn");

  if (nextBtn) {
    nextBtn.addEventListener("click", nextStep);
  }

  const prevBtn = document.getElementById("prevBtn");

  if (prevBtn) {
    prevBtn.addEventListener("click", prevStep);
    nextBtn.classList.remove("is-last-step");
  }

});

/* ======================================================
RENDER STEP
====================================================== */

// gets unique age options from routineMapping keys for step 1 UI
function getAgeOptions() {

  const ages = new Set();

  Object.keys(routineMapping).forEach(key => {
    const [age] = key.split("_");
    ages.add(age);
  });

  return [...ages];

}
// get unique skin type options from routineMapping keys for step 1 UI
function getSkinTypeOptions() {

  const skins = new Set();

  Object.keys(routineMapping).forEach(key => {
    const [, skin] = key.split("_");
    skins.add(skin);
  });

  return [...skins];

}

// get unique concern options based on selected age and skin type from routineMapping keys for step 1 UI
function getPrimaryConcerns() {

  const concerns = new Set();

  Object.keys(routineMapping).forEach(key => {

    const [age, skin, concern] = key.split("_");

    if (
      age === quizState.age &&
      skin === quizState.skinType
    ) {
      concerns.add(concern);
    }

  });

  return [...concerns];

}

// render step based on quizConfig and quizState
function renderStep() {


  const prevBtn = document.getElementById("prevBtn");

  if (prevBtn) {
    if (quizStep === 0) {
      prevBtn.style.display = "none";
    } else {
      prevBtn.style.display = "block";
    }
  }

  updateQuizProgress();

  const stepData = quizConfig[quizStep];


  // Update header title from Liquid
  const titleEl = document.querySelector("#step1 .quiz-title");

  if (titleEl && stepData && stepLabels) {
    const label = stepLabels[stepData.step] || "";
    titleEl.textContent = label;
  }

  const container = document.getElementById("quizContainer");

  const ageOptions = getAgeOptions();
  const skinOptions = getSkinTypeOptions();

  const skinTypeImages = {
    normal: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Normal.svg",
    oily: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Oily.svg",
    dry: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/DRY.svg",
    combination: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Combination.svg",
    sensitive: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Sensitive.svg"
  };

  const optionImages = {

    lifestyle: {
      "Don’t Get Enough Sleep": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Not_Enough_Sleep.svg",
      "Often Feel Stressed": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Stressed_Often.svg",
      "Mostly Balanced Routine": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Balanced_Routine.svg",
      "Mostly Indoors During the Day": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Mostly_Indoor.svg",
      "Outdoors a Lot": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Mosty_Outdoor.svg",
      "Poor Sleep & High Stress": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/High_Stress_Poor_Sleep.svg",
      "Mostly in AC / Indoor Spaces": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Mostly_in_AC.svg"
    },

    foodHabit: {
      "Enjoy Junk Food Occasionally": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Junk_Food.svg",
      "Eat a Fairly Balanced Diet": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Balanced_Diet.svg",
      "Mostly Eat Home-Cooked Food": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Home_Cooked.svg",
      "Try to Eat Clean Most Days": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Eat_Clean.svg",
      "Have Dairy Quite Often": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Dairy_Often.svg",
      "Don’t Drink Enough Water": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Don_t_Drink_Enough_Water.svg"
    },

    skinConcern: {
      acne: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Acne.svg",
      pigmentation: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Pigmentation.svg",
      glow: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Glow.svg",
      ageing: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Wrinkles.svg",
      dryness: "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Dryness.svg"
    },

    secondaryConcern: {

      "Excess Oil,Frequent Breakouts": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Excess_Oil.svg",
      "Frequent Breakouts": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Frequent_Breakout.svg",
      "Occasional Breakouts": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Ocassional_Breakout.svg",
      "Painful / Inflammatory Pimples": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Inflammatory_Pimples.svg",
      "Acne Marks & Scars": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Acne_Marks_Scars.svg",
      "Dark Spots & Marks": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Darks_Spots_Marks.svg",
      "Uneven Skin Tone": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Uneven_Skin_Tone.svg",
      "Dullness": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Dullness.svg",
      "Uneven Texture": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Uneven_Texture.svg",
      "Dehydration": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Dehydration.svg",
      "Early Fine Lines": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Early_Fine_Lines.svg",
      "Fine lines & Wrinkles": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Fine_Lines_Wrinkles.svg",
      "Sagging Skin": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Sagging_Skin.svg",
      "Well ageing": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Well_Ageing.svg",
      "Occasional Dryness": "https://cdn.shopify.com/s/files/1/0742/5160/0188/files/Dryness.svg"
    }
  };

  let ageHTML = "";
  ageOptions.forEach(age => {
    ageHTML += `
<label class="radio-card" data-question="Age" data-value="${age}">
<input type="radio" name="age" value="${age}"
${quizState.age === age ? "checked" : ""}>
<div class="card-ui">${age}</div>
</label>
`;
  });

  // let skinHTML = "";
  // skinOptions.forEach(skin=>{
  // skinHTML += `
  // <label class="radio-card">
  // <input type="radio" name="skinType" value="${skin}"
  // ${quizState.skinType === skin ? "checked" : ""}>
  // <div class="card-ui">${skin}</div>
  // </label>
  // `;
  // });

  let skinHTML = "";

  skinOptions.forEach(skin => {

    const img = skinTypeImages[skin] || "";

    skinHTML += `
<label class="radio-card"  data-question="Skin Type" data-value="${skin}">
<input type="radio" name="skinType" value="${skin}"
${quizState.skinType === skin ? "checked" : ""}>

<div class="card-ui">

${img ? `<img src="${img}" alt="${skin}" class="skin-icon">` : ""}

<span>${skin.charAt(0).toUpperCase() + skin.slice(1)}</span>

</div>

</label>
`;

  });


  /* STEP 1 UI */
  console.log("Quiz State at render: Page reload ");
  console.log("Rendering step:======= ", stepData.step);
  if (stepData.step === "details") {

    container.innerHTML = `

<div class="age-gropp-wrapper">
<h4>Age Group</h4>

<div class="radio-grid age-grid-range">
${ageHTML}
</div>
</div>



<h4>Skin Type</h4>

<div class="radio-grid skin-type-grid">
${skinHTML}
</div>


<div class="travelRange-range-wrapper">
<h4>Travel Frequency</h4>
<input type="range"
id="travelRange"
min="0"
max="2"
value="${["rarely", "occasionally", "frequently"].indexOf(quizState.travel ?? "rarely")}"
>
<div class="container-style-labels">
<div class="dot radio-card" data-question="Travel Frequency" data-value="rarely"></div>
<div class="dot radio-card" data-question="Travel Frequency" data-value="occasionally"></div>
<div class="dot radio-card" data-question="Travel Frequency" data-value="frequently"></div>
</div>
<div class="range-labels travelRange-labels">
<span>Rarely</span>
<span>Occasionally</span>
<span>Frequently</span>
</div>
</div>



<div class="pollutionRange-range-wrapper">
<h4>Sun Exposure</h4>
<input type="range"
id="pollutionRange"
min="0"
max="2"
value="${["Minimal", "Moderate", "High"].indexOf(quizState.pollution ?? "Minimal")}"
>
<div class="container-style-labels">
<div class="dot radio-card" data-question="Sun Exposure" data-value="Minimal"></div>
<div class="dot radio-card" data-question="Sun Exposure" data-value="Moderate"></div>
<div class="dot radio-card" data-question="Sun Exposure" data-value="High"></div>
</div>
<div class="range-labels pollutionRange-labels">
<span>Minimal</span>
<span>Moderate</span>
<span>High</span>
</div>
</div>

`;

    attachDetailsEvents();

    return;

  }




  /* OTHER STEPS */

  let options = stepData.options || [];

  if (stepData.step === "skinConcern") {
    options = getPrimaryConcerns();
  }

  if (stepData.dynamic) {
    options = generateSecondaryOptions();
  }

  let html = `<h3>${stepData.title}</h3><div class="radio-grid ${stepData.step.toLowerCase().replace(/\s/g, "-")}-grid">`;

  options.forEach(opt => {

    const img = optionImages?.[stepData.step]?.[opt];

    html += `
<label class="radio-card" data-question="${stepData.title}" data-value="${opt}">
<input type="radio"
name="${stepData.step}"
value="${opt}"
${quizState[stepData.step] === opt ? "checked" : ""}
>

<div class="card-ui">

${img ? `<img src="${img}" class="option-icon ${stepData.step.toLowerCase().replace(/\s/g, "-")}-icon">` : ""}

<span>${opt}</span>

</div>

</label>
`;

  });

  html += `</div>`;




  container.innerHTML = html;

  attachRadioEvents();

}

function attachDetailsEvents() {

  const nextBtn = document.getElementById("nextBtn");

  const radios = document.querySelectorAll('input[name="age"], input[name="skinType"]');

  radios.forEach(input => {

    input.addEventListener("change", () => {

      quizState[input.name] = input.value;

      checkStep1Complete();

      saveState();

      // after picking Skin Type, reveal the next section (Travel Frequency)
      if (input.name === "skinType") {
        scrollToEl(document.querySelector('.travelRange-range-wrapper'));
      }

    });

  });

  // const travelInputs = document.querySelectorAll('input[name="travel"]');
  // const pollutionInputs = document.querySelectorAll('input[name="pollution"]');

  // travelInputs.forEach(input=>{
  //   input.addEventListener("change",()=>{
  //     quizState.travel = input.value;
  //     checkStep1Complete();
  //     saveState();
  //   });
  // });

  // pollutionInputs.forEach(input=>{
  //   input.addEventListener("change",()=>{
  //     quizState.pollution = input.value;
  //     checkStep1Complete();
  //     saveState();
  //   });
  // });

  const travelRange = document.getElementById("travelRange");
  const pollutionRange = document.getElementById("pollutionRange");

  const travelValues = ["rarely", "occasionally", "frequently"];
  const pollutionValues = ["Minimal", "Moderate", "High"];


  /* restore slider state */

  quizState.travel = travelValues[travelRange.value];
  quizState.pollution = pollutionValues[pollutionRange.value];


  /* slider events */

  travelRange.addEventListener("input", () => {

    quizState.travel = travelValues[travelRange.value];

    checkStep1Complete();

    saveState();

  });

  pollutionRange.addEventListener("input", () => {

    quizState.pollution = pollutionValues[pollutionRange.value];

    checkStep1Complete();

    saveState();

  });

  // scroll on "change" (fires once, after release) rather than "input"
  // (fires continuously while dragging) so the page doesn't jump mid-drag
  travelRange.addEventListener("change", () => {
    scrollToEl(document.querySelector('.pollutionRange-range-wrapper'));
  });

  pollutionRange.addEventListener("change", () => {
    scrollToEl(document.querySelector('#step1 .actions'));
  });


  /*  important fix */

  setTimeout(() => {
    checkStep1Complete();
  }, 50);

}

function checkStep1Complete() {

  const nextBtn = document.getElementById("nextBtn");

  if (
    quizState.age &&
    quizState.skinType &&
    quizState.travel !== undefined &&
    quizState.pollution !== undefined
  ) {
    nextBtn.classList.remove("disabled");
  } else {
    nextBtn.classList.add("disabled");
  }

}

/* ======================================================
SCROLL HELPERS
====================================================== */

// same header-offset convention used by goToRoutineStep()
function getStickyHeaderOffset() {
  const header = document.querySelector('.site-header');
  return header ? header.offsetHeight + 20 : 120;
}

function scrollToEl(el) {

  if (!el) return;

  const offset = getStickyHeaderOffset();
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: Math.max(top, 0),
    behavior: "smooth"
  });

}

// lands on the question header at the top of the current quiz step
function scrollToQuizTop() {
  scrollToEl(document.querySelector('#step1 .quiz-header') || document.getElementById('step1'));
}

/* ======================================================
SAVE INPUT
====================================================== */

// function attachRadioEvents(){

// document.querySelectorAll("#quizContainer input")
// .forEach(input=>{

// input.addEventListener("change",function(){

// quizState[this.name] = this.value;

// document.getElementById("nextBtn")
// .classList.remove("disabled");

// });

// });

// }

function attachRadioEvents() {

  document.querySelectorAll("#quizContainer input[type='radio']")
    .forEach(input => {

      input.addEventListener("change", function () {

        quizState[this.name] = this.value;

        saveState();


        // 🔥 Ensure quizStep stays correct
if (quizStep === quizConfig.length - 1) {
  updateNextButtonState();
}

        const btn = document.getElementById("nextBtn");
        btn.classList.remove("disabled");

        scrollToQuizTop();

      });

    });

}


/* ======================================================
VALIDATION
====================================================== */
function validateStep() {

  if (!quizConfig[quizStep]) {
    console.warn("Invalid quizStep:", quizStep);
    quizStep = 0;
  }

  const step = quizConfig[quizStep]?.step;
  console.log("Validating step:", step);
  /* STEP 1 VALIDATION */

  if (step === "details") {

    if (!quizState.age || !quizState.skinType) {
      alert("Please select age and skin type");
      return false;
    }

    return true;

  }

  /* PRIMARY CONCERN VALIDATION */

  if (step === "skinConcern") {

    if (!quizState.skinConcern) {
      alert("Please select a Primary Concern");
      return false;
    }

  }

  /* SECONDARY CONCERN VALIDATION */

  if (step === "secondaryConcern") {

    if (!quizState.secondaryConcern) {
      alert("Please choose one option in 'Select Concern Detail'");
      return false;
    }

  }

  /* GENERIC VALIDATION */

  if (!quizState[step]) {
    alert("Please select an option");
    return false;
  }

  return true;

}


/* ======================================================
NEXT STEP
====================================================== */
function nextStep() {

  

  const btn = document.getElementById("nextBtn");

  if (btn.classList.contains("disabled")) return;

  if (!validateStep()) return;

  // cleverTap Event quiz step completed
  const stepData = quizConfig[quizStep];

  if (!stepData) {
    console.warn("Invalid step in nextStep:", quizStep);
    return;
  }

  const stepKey = stepData.step;


  let eventData = {};

  if (stepKey === "details") {
    //  Step 1 (multiple questions)
    eventData = {
      "Age": quizState.age || "",
      "Skin Type": quizState.skinType || "",
      "Travel Frequency": quizState.travel || "",
      "Sun Exposure": quizState.pollution || ""
    };
  } else {
    //  Normal steps
    eventData = {
      [stepKey]: quizState[stepKey]
    };
  }

  //  Fire CleverTap Event
  clevertap.event.push("Regime_Question", eventData);

  console.log("Regime_Question:", eventData);



  quizStep++;

  if (quizStep === quizConfig.length - 1) {

    btn.innerText = "Build Routine";
    btn.classList.add("is-last-step");
    btn.removeEventListener("click", nextStep);
    btn.addEventListener("click", buildRoutine);

  }
  else
  {
    btn.classList.remove("is-last-step");
  }


  renderStep();

  saveState();

  // scroll after the new step has rendered, so it targets final layout height
  requestAnimationFrame(scrollToQuizTop);

}

function prevStep() {

  if (quizStep === 0) return;

  quizStep--;

  const btn = document.getElementById("nextBtn");

  btn.innerText = "Next";

  btn.removeEventListener("click", buildRoutine);
  btn.addEventListener("click", nextStep);
  btn.classList.remove("is-last-step");
  renderStep();

  saveState();

  requestAnimationFrame(scrollToQuizTop);

}

/* ======================================================
SECONDARY OPTIONS
====================================================== */

// function generateSecondaryOptions(){

// const age = quizState.age;
// const skin = quizState.skinType;
// const concern = quizState.skinConcern;

// const set = new Set();

// Object.keys(routineMapping).forEach(key=>{

// const parts = key.split("_");

// if(parts[0]===age && parts[1]===skin && parts[2]===concern){
// set.add(parts.slice(3).join("_"));
// }

// });

// return [...set];

// }

function generateSecondaryOptions() {

  const options = new Set();

  Object.keys(routineMapping).forEach(key => {

    const [age, skin, concern, secondary] = key.split("_");

    if (
      age === quizState.age &&
      skin === quizState.skinType &&
      concern === quizState.skinConcern
    ) {
      secondary.split("_").forEach(s => {
        options.add(s.trim());
      });
    }

  });

  return [...options];

}

/* ======================================================
BUILD ROUTINE → LOAD STEP 2
====================================================== */

async function buildRoutine() {

  /* VALIDATE SECONDARY CONCERN */

  if (!quizState.secondaryConcern) {
    alert("Please select a Concern Detail before building your routine.");
    return;
  }

  // CleverTap Event
  const analyticsData = getQuizAnalyticsData();

  console.log("Quiz Data:", analyticsData);

  // Example CleverTap
  if (window.clevertap) {
    clevertap.event.push("Regime_Values", analyticsData);
  }

  const routineKey =
    `${quizState.age}_${quizState.skinType}_${quizState.skinConcern}_${quizState.secondaryConcern}`;

  const routine = routineMapping[routineKey];

  if (!routine) {

    document.getElementById("quizContainer").innerHTML =
      "<p>No routine available for this selection.</p>";

    return;

  }

  /* save routine */

  routineData = routine;

  /* map quiz state to step2 engine variables */

  selectedAge = quizState.age;
  selectedSkinType = quizState.skinType;
  selectedSkinConcern = quizState.skinConcern;
  selectedSecondaryConcern = quizState.secondaryConcern;

  /* reset arrays */

  selectedProducts = [];
  selectedproductsHandle = [];
  routineStep = 0;

  /* hide quiz */

  const step1 = document.getElementById("step1");
  if (step1) step1.style.display = "none";

  /* show step2 */

  const step2 = document.getElementById("step2");
  if (step2) step2.style.display = "block";

  /* update title */

  const title = document.querySelector(".title2");

  if (title) {

    title.innerText =
      `${selectedSkinType.charAt(0).toUpperCase() + selectedSkinType.slice(1)} + ${selectedSkinConcern} Skin`;

  }

  /* load routine tabs + products */

  await loadRoutineSteps();

}

/* ------------------------------------------------------
Loader Helpers
------------------------------------------------------ */

function showLoader() {
  const loader = document.getElementById('loader');
  if (loader) loader.style.display = 'flex';
}
function hideLoader() {
  const loader = document.getElementById('loader');
  if (loader) loader.style.display = 'none';
}


// This function loads routine steps and products based on the user's quiz selections. It shows a loader while fetching data, dynamically creates tabs and product cards, and handles out-of-stock scenarios.

/* ------------------------------------------------------
4. Step 2: Guided Routine with Tabs + Routine Strip + Add to Cart
------------------------------------------------------ */

const tabsContainer = document.querySelector('.routine-tabs');
const contentContainer = document.querySelector('.routine-content');
// const nextBtn = document.getElementById('nextBtn');
const nextBtn = document.getElementById('routineNextBtn');
const backToInputBtn = document.getElementById('backToInput');

async function fetchVariant(productHandle) {
  console.log(productHandle, ">>>>>>>>>>>>>>>>>");
  const res = await fetch(`/products/${productHandle}.js`);
  return await res.json();
}


async function loadRoutineSteps() {
  showLoader();
  tabsContainer.innerHTML = "";
  contentContainer.innerHTML = "";

  // const combo = routineMapping[selectedSkinType]?.routines?.[selectedSkinConcern];

  const routineKey =
    `${selectedAge}_${selectedSkinType}_${selectedSkinConcern}_${selectedSecondaryConcern}`;

  const combo = routineMapping[routineKey];

  console.log("Routine Key:", routineKey);

  if (!combo) {
    alert("No routine available for this combination.");
    hideLoader();
    return;
  }

  routine = combo;
  console.log("Loaded Routine:", routine);
  
  for (let i = 0; i < routine.steps.length; i++) {
    const stepName = routine.steps[i];
    // const product = routine.products[stepName];
    const productKey = routine.products[stepName];
    const product = productLibrary[productKey];

    console.log(product, "??????????");

    const data = await fetchVariant(product.productHandle);
    const variant = data.variants[0];
    const variantId = variant?.id;
    const price = (parseFloat(data.price) / 100).toFixed(2);

    // Check availability
    const inStock = variant?.available === true;

    // Create tab (always render the tab)
    const li = document.createElement('li');
    li.textContent = stepName;
    li.dataset.step = stepName;
    if (i === routineStep) li.classList.add('active');
    tabsContainer.appendChild(li);

    // If product is out of stock, mark the card as disabled
    const outOfStockHTML = `
      <div class="product-card out-of-stock">
        <div class="prd-top">
          <div class="prd-img">
            <img src="${data.featured_image || ''}" alt="${data.title}" width="180">
          </div>
          <div class="prd-desc">
            <p class="card-prd-title"><strong>${data.title.toLowerCase()}</strong></p>
            <p class="card-prd-price">₹${price}</p>
            <p class="out-of-stock-label">Out of Stock</p>
          </div>
        </div>
      </div>
    `;

    // Normal in-stock product card
    const inStockHTML = `
      <div class="product-card">
        <div class="prd-top" data-click-toggle="true">
          <div class="prd-img">
            <img src="${data.featured_image || ''}" alt="${data.title}" width="180">
          </div>
          <div class="prd-desc">
            <div class="usage-frequency"><p class="step-frequency">${product.frequency}</p></div>
            <p class="card-prd-title"><strong>${data.title.toLowerCase()}</strong></p>
            <p class="card-prd-price">₹${price}</p>
          </div>
          <label>
            <input type="checkbox" data-id="${variantId}" data-handle="${product.productHandle}" checked>
          </label>
        </div>
        <div class="prd-bottom">
          <details>
            <summary class="htulabel">How to Use?</summary>
            <ul class="howtouselist">
              ${product.howToUse.map(step => `<li>${step}</li>`).join('')}
            </ul>
          </details>
        </div>
      </div>
    `;

    // Combine full step card
    const div = document.createElement('div');
    div.className = `routine-step ${stepName} ${i === routineStep ? 'active' : ''}`;
    div.innerHTML = `
      <div class="prd-info">${product.info}</div>
      <div class="prd-ingredient-wrapper">
        <div class="prd-ingredient">${product.ingredients}</div>
        <div class="prd-ingredient-info">
          <ul class="ingredientlist">
            ${product.ingredientInfo.map(step => `<li>${step}</li>`).join('')}
          </ul>
        </div>
        ${product.recomdLine ? `<div class="recommendation-line">${product.recomdLine}</div>` : ''}
      </div>

      ${inStock ? inStockHTML : outOfStockHTML}

      <!-- Routine Strip will render below product card -->
      <div class="routine-strip" id="routineStrip-${i}"></div>

      <!-- Add to Cart Button only in the LAST tab -->
      ${i === routine.steps.length - 1 ? `
      <div class="actions">
        <button id="addToCart" class="byr-btn">
          <h3 class="totalprice">Total: ₹<span id="totalPrice">0</span></h3>
          <span>Add to Cart →</span>
        </button>
      </div>` : ""}
    `;

    contentContainer.appendChild(div);

    // Add product only if it's in stock
    if (inStock) {
      if (!selectedProducts.includes(variantId)) selectedProducts.push(variantId);
      if (!selectedproductsHandle.includes(product.productHandle)) selectedproductsHandle.push(product.productHandle);
    }
  }

  attachTabEvents();
  attachCheckboxEvents();
  updateTotalPrice();
  renderAllRoutineStrips();
  // resetNextButtonVisibility();
  attachNextButtonHandler(); // ADD THIS LINE
  // --- Reset Next Button Visibility ---
  // if (nextBtn) {
  //   const totalTabs = document.querySelectorAll('.routine-tabs li').length;
  //   if (totalTabs > 1) {
  //     nextBtn.style.display = 'block';
  //   } else {
  //     nextBtn.style.display = 'none';
  //   }
  // }

  updateNextButtonVisibility();
  hideLoader();
  saveState();
}
/* ======================================================
RENDER ROUTINE TABS
====================================================== */

function renderRoutineTabs() {

  const container = document.getElementById("quizContainer");

  let html = `<ul class="routine-tabs">`;

  routineData.steps.forEach((step, i) => {

    html += `
<li class="${i === 0 ? 'active' : ''}" data-step="${step}">
${step}
</li>
`;

  });

  html += `</ul><div id="routineProducts"></div>`;

  container.innerHTML = html;

  // attachTabSwitch();
  // attachTabEvents();
  saveState();
}


/* ======================================================
LOAD PRODUCTS
====================================================== */

async function loadRoutineProducts() {

  const container = document.getElementById("routineProducts");

  container.innerHTML = "";

  for (const step of routineData.steps) {

    const key = routineData.products[step];

    if (!productLibrary[key]) continue;

    const handle = productLibrary[key].productHandle;

    const product = await fetchProduct(handle);

    const variant = product.variants[0];
    const price = (variant.price / 100).toFixed(2);

    container.innerHTML += `

<div class="routine-step" data-step="${step}">

<div class="product-card">

<div class="prd-top">

<input type="checkbox"
class="routine-checkbox"
data-id="${variant.id}"
data-price="${variant.price}"
checked>

<div class="prd-img">
<img src="${product.featured_image}">
</div>

<div class="prd-desc">
<p class="card-prd-title"><strong>${product.title}</strong></p>
<p class="card-prd-price">₹${price}</p>
</div>

</div>

</div>

</div>

`;

  }

  /* show first tab */

  document.querySelectorAll(".routine-step")
    .forEach((el, i) => {
      el.style.display = i === 0 ? "block" : "none";
    });

  renderAddToCart();
  attachCheckboxLogic();

}


/* ======================================================
FETCH PRODUCT
====================================================== */

async function fetchProduct(handle) {

  if (productCache[handle]) return productCache[handle];

  const res = await fetch(`/products/${handle}.js`);
  const data = await res.json();

  productCache[handle] = data;

  return data;

}


/* ======================================================
TAB SWITCH
====================================================== */

function attachTabSwitch() {

  document.querySelectorAll(".routine-tabs li")
    .forEach(tab => {

      tab.addEventListener("click", function () {

        document.querySelectorAll(".routine-tabs li")
          .forEach(t => t.classList.remove("active"));

        this.classList.add("active");

        const step = this.dataset.step;

        document.querySelectorAll(".routine-step")
          .forEach(sec => {

            sec.style.display =
              sec.dataset.step === step ? "block" : "none";

          });

      });

    });

}


/* ======================================================
CHECKBOX LOGIC
====================================================== */

function attachCheckboxLogic() {

  document.querySelectorAll(".routine-checkbox")
    .forEach(box => {

      box.addEventListener("change", updateTotal);

    });

  updateTotal();

}


/* ======================================================
TOTAL PRICE
====================================================== */

function updateTotal() {

  let total = 0;

  document.querySelectorAll(".routine-checkbox:checked")
    .forEach(box => {
      total += parseInt(box.dataset.price);
    });

  const price = (total / 100).toFixed(2);

  const el = document.getElementById("totalRoutinePrice");

  if (el) {
    el.innerText = `₹${price}`;
  }

}


/* ======================================================
ADD TO CART UI
====================================================== */

function renderAddToCart() {

  const container = document.getElementById("routineProducts");

  container.insertAdjacentHTML("beforeend", `

<div class="actions">

<button id="addRoutineToCart" class="byr-btn">

Add Selected To Cart
<span id="totalRoutinePrice"></span>

</button>

</div>

`);

  document
    .getElementById("addRoutineToCart")
    .addEventListener("click", addRoutineToCart);

}


/* ======================================================
ADD TO CART
====================================================== */

async function addRoutineToCart() {

  const items = [];

  document.querySelectorAll(".routine-checkbox:checked")
    .forEach(box => {
      items.push({ id: box.dataset.id, quantity: 1 });
    });

  await fetch("/cart/add.js", {

    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items })

  });

  document.dispatchEvent(new CustomEvent("cart:refresh"));

  alert("Routine added to cart");

}


/* ------------------------------------------------------
Tabs Navigation
------------------------------------------------------ */

function attachTabEvents() {
  const tabs = document.querySelectorAll('.routine-tabs li');
  const steps = document.querySelectorAll('.routine-step');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      // Remove active states
      tabs.forEach(t => t.classList.remove('active'));
      steps.forEach(step => step.classList.remove('active'));

      // Activate selected tab + step
      tab.classList.add('active');
      steps[index].classList.add('active');

      tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

      // Update current step
      routineStep = index;


      if (routineStep === tabs.length - 1) {
        renderAllRoutineStrips();
      }

      updateNextButtonVisibility();

      console.log("attachTabEvents =Routine Step:", routineStep, "Total Tabs:", tabs.length);

      saveState();
    });
  });
}

/* ------------------------------------------------------
Update Total Price Dynamically
------------------------------------------------------ */
async function updateTotalPrice() {
  let total = 0;
  for (let handle of selectedproductsHandle) {
    const data = await fetchVariant(handle);
    total += parseFloat(data.price) / 100;
  }
  const totalEl = document.getElementById('totalPrice');
  if (totalEl) totalEl.textContent = total.toFixed(2);
}

/* ------------------------------------------------------
Add to Cart Button handler WEB/APP
------------------------------------------------------ */

async function websiteAddToCartHandler() {
  const isApp = window.ReactNativeWebView || window.appbrew || window.appbrewSDK;

  // No products selected → safety guard
  if (!selectedProducts || selectedProducts.length === 0) return;

  // --- Loader UI ---
  const addBtn = document.getElementById('addToCart');
  if (addBtn) {
    addBtn.disabled = true;
    const originalHTML = addBtn.innerHTML;
    addBtn.dataset.originalHtml = originalHTML;
    addBtn.innerHTML = `<span class="loading-spinner"></span> Adding...`;
  }

  try {

    //  ----APPBREW FLOW----

    if (isApp && window.appbrewSDK?.addToCart) {
      for (let variantId of selectedProducts) {
        await window.appbrewSDK.addToCart(
          null, // handle optional
          `gid://shopify/ProductVariant/${variantId}`,
          1
        );
      }

      appBrewgotoCart();
      showToast();

      return;
    }

    //  ----WEB FLOW (Shopify)----

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    const items = selectedProducts.map(id => ({
      id,
      quantity: 1
    }));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items,
        ...(cart && {
          sections: cart.getSectionsToRender().map(s => s.id),
          sections_url: window.location.pathname
        })
      })
    });

    const data = await response.json();

    if (cart) {
      cart.renderContents(data);
      cart.classList.remove('is-empty');
    }

  } catch (err) {
    console.error('Add to cart failed:', err);
  } finally {
    // --- Restore button ---
    if (addBtn) {
      addBtn.disabled = false;
      addBtn.innerHTML = addBtn.dataset.originalHtml;
    }
  }
}

/* ------------------------------------------------------
Add to Cart Button (on last tab only)
------------------------------------------------------ */

document.addEventListener('click', e => {
  const addBtn = e.target.closest('#addToCart');
  if (!addBtn) return;

  websiteAddToCartHandler();
});



/* ------------------------------------------------------
Checkbox change → update strip and totals
------------------------------------------------------ */
function attachCheckboxEvents() {
  document.querySelectorAll('.routine-step input[type="checkbox"]').forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const pid = parseInt(checkbox.dataset.id);
      const phandle = checkbox.dataset.handle;

      if (checkbox.checked) {
        if (!selectedProducts.includes(pid)) selectedProducts.push(pid);
        if (!selectedproductsHandle.includes(phandle)) selectedproductsHandle.push(phandle);
      } else {
        selectedProducts = selectedProducts.filter(id => id !== pid);
        selectedproductsHandle = selectedproductsHandle.filter(h => h !== phandle);
      }

      updateTotalPrice();
      renderAllRoutineStrips();
      updateAddToCartButtonState();
      saveState();
    });
  });
}

/* ------------------------------------------------------
Routine Strip Logic
------------------------------------------------------ */

// Renders all routine strips below each step card
async function renderAllRoutineStrips() {
  const tabs = document.querySelectorAll('.routine-tabs li');
  if (routineStep === tabs.length - 1) {
    await renderRoutineStrip();
  }
}



// Render individual strip for a tab
async function renderRoutineStrip() {
  if (isRenderingStrip) return;
  isRenderingStrip = true;

  const lastStepIndex = routine.steps.length - 1;
  const stripId = `routineStrip-${lastStepIndex}`;
  const strip = document.getElementById(stripId);

  if (!strip) {
    isRenderingStrip = false;
    return;
  }

  showLoader();
  strip.innerHTML = '';

  // const combo = routineMapping[selectedSkinType]?.routines?.[selectedSkinConcern];

  const routineKey =
    `${selectedAge}_${selectedSkinType}_${selectedSkinConcern}_${selectedSecondaryConcern}`;

  const combo = routineMapping[routineKey];

  if (!combo) {
    hideLoader();
    isRenderingStrip = false;
    return;
  }

  // Deduplicate selected handles
  selectedproductsHandle = [...new Set(selectedproductsHandle)];

  // Collect info for data attributes
  const selectedNames = [];
  const selectedPrices = [];
  let totalPrice = 0;

  for (let j = 0; j < combo.steps.length; j++) {
    const stepNumber = j + 1;
    const stepName = `Step ${stepNumber}`;
    // const product = combo.products[combo.steps[j]];
    // const phandle = product.productHandle;

    const stepNamee = combo.steps[j];
    const product = combo.products[stepNamee];
    const phandle = productLibrary[product];
    console.log(phandle, "phandle>>>>>>>>>>>>>>>>");

    const isSelected = selectedproductsHandle.includes(phandle.productHandle);
    const data = await fetchVariant(phandle.productHandle);
    const image = data.featured_image || '';
    const productName = data.title || stepName;
    const productPrice = parseFloat(data.price / 100 || 0);

    if (isSelected) {
      selectedNames.push(productName);
      selectedPrices.push(productPrice.toFixed(2));
      totalPrice += productPrice;
    }

    strip.innerHTML += isSelected
      ? `<div class="strip-item">
          <span class="remove-btn" onclick="toggleRoutineSelection('${phandle.productHandle}')">×</span>
          <img src="${image}" alt="Step ${j + 1}">
        </div>`
      : `<div class="strip-item add-item"
            data-step-index="${j}"
            onclick="goToRoutineStep(${j})">
            <p>ADD<br>Step ${j + 1}</p>
        </div>`;

  }

  hideLoader();
  isRenderingStrip = false;

  // Update data attributes for analytics or tracking
  const addToCartBtn = document.getElementById('addToCart');
  if (addToCartBtn) {
    addToCartBtn.dataset.productNames = selectedNames.join(', ');
    addToCartBtn.dataset.productPrices = selectedPrices.join(', ');
    addToCartBtn.dataset.productCount = selectedNames.length;
    addToCartBtn.dataset.totalPrice = totalPrice.toFixed(2);
  }
}





/* ------------------------------------------------------
Ensure Next Button resets when routine loads
------------------------------------------------------ */
function resetNextButtonVisibility() {
  const tabs = document.querySelectorAll('.routine-tabs li');
  if (nextBtn) {
    if (tabs.length <= 1) {
      nextBtn.style.display = 'none';
    } else if (routineStep === tabs.length - 1) {
      nextBtn.style.display = 'none';
    } else {
      nextBtn.style.display = 'block';
    }
  }
}



/* ------------------------------------------------------
Making prd-card clickable.
------------------------------------------------------ */

document.addEventListener('click', (e) => {
  const prdTop = e.target.closest('.prd-top[data-click-toggle]');
  if (!prdTop) return;

  // If user clicked directly on checkbox, let default behavior happen
  if (e.target.matches('input[type="checkbox"]')) return;

  const checkbox = prdTop.querySelector('input[type="checkbox"]');
  if (!checkbox || checkbox.disabled) return;

  // Toggle checkbox state
  checkbox.checked = !checkbox.checked;

  // Trigger change event so existing logic runs
  checkbox.dispatchEvent(new Event('change', { bubbles: true }));
});


/* ------------------------------------------------------
Ensure ATC Button resets when routine loads
------------------------------------------------------ */
function updateAddToCartButtonState() {
  const addToCartBtn = document.getElementById('addToCart');
  if (!addToCartBtn) return;

  // Check if any product is selected
  if (selectedProducts && selectedProducts.length > 0) {
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled');
  } else {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
  }
}
/* ------------------------------------------------------
2. Session Storage Helpers
------------------------------------------------------ */
function saveState() {

  const state = {
    quizState,
    quizStep,
    selectedAge,
    selectedSkinType,
    selectedSkinConcern,
    selectedSecondaryConcern,
    selectedProducts,
    selectedproductsHandle
  };

  sessionStorage.setItem(
    ROUTINE_SESSION_KEY,
    JSON.stringify(state)
  );

}



// Toggles selection when clicking × on routine strip
async function toggleRoutineSelection(phandle) {
  const data = await fetchVariant(phandle);
  const variantId = data.variants[0]?.id;

  const checkbox = document.querySelector(`input[data-handle="${phandle}"]`);
  const isChecked = selectedproductsHandle.includes(phandle);

  if (isChecked) {
    selectedProducts = selectedProducts.filter(id => id !== variantId);
    selectedproductsHandle = selectedproductsHandle.filter(h => h !== phandle);
    if (checkbox) checkbox.checked = false;
  } else {
    selectedProducts.push(variantId);
    selectedproductsHandle.push(phandle);
    if (checkbox) checkbox.checked = true;
  }

  updateTotalPrice();
  renderAllRoutineStrips();
  updateAddToCartButtonState()
  saveState();
}


/* ------------------------------------------------------
Tab switch on routine strip item click.
------------------------------------------------------ */

function goToRoutineStep(stepIndex) {
  const tabs = document.querySelectorAll('.routine-tabs li');
  const steps = document.querySelectorAll('.routine-step');
  const tabsContainer = document.querySelector('.routine-tabs');

  if (!tabs[stepIndex] || !steps[stepIndex]) return;

  // Remove current active state
  tabs.forEach(t => t.classList.remove('active'));
  steps.forEach(s => s.classList.remove('active'));

  // Activate target step
  tabs[stepIndex].classList.add('active');
  steps[stepIndex].classList.add('active');
  routineStep = stepIndex;

  // Horizontal scroll to tab
  tabs[stepIndex].scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest'
  });

  // Vertical scroll to product card (with sticky header offset)
  const header = document.querySelector('.site-header');
  const headerOffset = header ? header.offsetHeight + 20 : 120;

  const stepTop = steps[stepIndex].getBoundingClientRect().top;
  const offsetPosition = window.scrollY + stepTop - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });

  updateNextButtonVisibility();


  saveState();
}

/* ------------------------------------------------------
STEP 2 NEXT BUTTON LOGIC
------------------------------------------------------ */

// function attachNextButtonHandler() {

//   const nextBtn = document.getElementById('routineNextBtn');
//   if (!nextBtn) return;

//   nextBtn.addEventListener('click', () => {

//     const tabs = document.querySelectorAll('.routine-tabs li');
//     const steps = document.querySelectorAll('.routine-step');

//     if (!tabs.length) return;

//     routineStep++;

//     if (routineStep < tabs.length) {

//       tabs.forEach(t => t.classList.remove('active'));
//       steps.forEach(s => s.classList.remove('active'));

//       tabs[routineStep].classList.add('active');
//       steps[routineStep].classList.add('active');

//       tabs[routineStep].scrollIntoView({
//         behavior: 'smooth',
//         inline: 'center',
//         block: 'nearest'
//       });

//     }

//     if (routineStep === tabs.length - 1) {
//       nextBtn.style.display = 'none';
//       renderAllRoutineStrips();
//     }

//     saveState();

//   });

// }

function attachNextButtonHandler() {

  let nextBtn = document.getElementById('routineNextBtn');
  if (!nextBtn) return;

  //  remove old listeners
  nextBtn.replaceWith(nextBtn.cloneNode(true));
  nextBtn = document.getElementById('routineNextBtn');

  nextBtn.addEventListener('click', () => {

    const tabs = document.querySelectorAll('.routine-tabs li');
    const steps = document.querySelectorAll('.routine-step');

    if (!tabs.length) return;

    // ✅ SAFE increment
    if (routineStep < tabs.length - 1) {
      routineStep++;
    }

    tabs.forEach(t => t.classList.remove('active'));
    steps.forEach(s => s.classList.remove('active'));

    tabs[routineStep].classList.add('active');
    steps[routineStep].classList.add('active');

    tabs[routineStep].scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });

    if (routineStep === tabs.length - 1) {
      renderAllRoutineStrips();
    }

    updateNextButtonVisibility();

    console.log("attachNextButtonHandler = Routine Step:", routineStep, "Total Tabs:", tabs.length);
    saveState();

  });

}

function restoreState() {

  const saved = sessionStorage.getItem(ROUTINE_SESSION_KEY);

  if (quizStep < 0 || quizStep >= quizConfig.length) {
    quizStep = 0;
}

  if (!saved) return;

  const state = JSON.parse(saved);

  if (!state) return;

  Object.assign(quizState, state.quizState || {});

  quizStep = state.quizStep ?? 0;

  selectedAge = state.selectedAge;
  selectedSkinType = state.selectedSkinType;
  selectedSkinConcern = state.selectedSkinConcern;
  selectedSecondaryConcern = state.selectedSecondaryConcern;

  selectedProducts = state.selectedProducts || [];
  selectedproductsHandle = state.selectedproductsHandle || [];

}

// Back → go to last quiz step before routine
backToInputBtn.addEventListener('click', () => {

  document.getElementById('step2').style.display = "none";
  document.getElementById('step1').style.display = "block";

  // go to last quiz step
  quizStep = quizConfig.length - 1;

  // render last quiz screen
  renderStep();
  checkStep1Complete();

  const nextBtn = document.getElementById("nextBtn");

  if (nextBtn) {

    nextBtn.style.display = "block";
    nextBtn.innerText = "Build Routine";
    nextBtn.classList.add("is-last-step");
    nextBtn.removeEventListener("click", nextStep);
    nextBtn.addEventListener("click", buildRoutine);

  }
  else
  {
    nextBtn.classList.remove("is-last-step");
  }

});



// Updates the quiz progress bar and step indicators based on the current step and total steps in the quiz configuration.

function updateQuizProgress() {

  const totalSteps = quizConfig.length;
  const progress = ((quizStep + 1) / totalSteps) * 100;

  const bar = document.getElementById("quizProgressFill");
  const current = document.getElementById("quizStepCurrent");
  const total = document.getElementById("quizStepTotal");

  if (bar) bar.style.width = progress + "%";
  if (current) current.innerText = quizStep + 1;
  if (total) total.innerText = totalSteps;

}


function getQuizAnalyticsData() {

  return {
    "Age": quizState.age || "",
    "Skin Type": quizState.skinType || "",
    "Travel Frequency": quizState.travel || "",
    "Sun Exposure": quizState.pollution || "",
    "Lifestyle": quizState.lifestyle || "",
    "Eating Habits": quizState.foodHabit || "",
    "Skin Concern": quizState.skinConcern || "",
    "Secondary Concern": quizState.secondaryConcern || ""
  };

}


function updateNextButtonVisibility() {
  const tabs = document.querySelectorAll('.routine-tabs li');
  const nextBtn = document.getElementById('routineNextBtn');

  if (!nextBtn || !tabs.length) return;

  if (routineStep === tabs.length - 1) {
    nextBtn.style.display = 'none';
  } else {
    nextBtn.style.display = 'block';
  }
}

function updateNextButtonState() {
  const btn = document.getElementById("nextBtn");
  if (!btn) return;

  // Remove all previous listeners (important)
  btn.replaceWith(btn.cloneNode(true));
  const newBtn = document.getElementById("nextBtn");

  if (quizStep === quizConfig.length - 1) {
    // 🔥 LAST STEP
    newBtn.innerText = "Build Routine";
    newBtn.classList.add("is-last-step");

    newBtn.addEventListener("click", buildRoutine);

  } else {
    // 🔥 NORMAL STEP
    newBtn.innerText = "Next";
    newBtn.classList.remove("is-last-step");
    newBtn.addEventListener("click", nextStep);
  }
}